import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../../utill/validation";
import { Collapse, Row, Space } from "antd";
import axios from "axios";
import api from "../../config.json";
import Table from "../../Common/table";
import dateTime from "../../utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../../utill/Excelimport";
import Loading from "../../utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import _ from "lodash";
import Operation from "antd/lib/transfer/operation";
import { generateExcelFile } from "../../utill/download";
import PaginationComponent from "../../Common/PaginationComponent";

const OilCheckpoints  = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "PartID",
    order: "asc",
  });
  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Inputdata, setInputData] = useState({});
  const [componentList, setcomponentList] = useState([]);
  const [modelState, setmodelState] = useState(false);
  const [modelState1, setmodelState1] = useState(false);

  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [VendorList, setVendorList] = useState([]);
  const [RMStorageList, setRMStorageList] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [ImageList, setImageList] = useState([]);
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [Data, setData] = useState([]);
  const [PdfData, setPdfData] = useState([]);
  const [QRCodeArray, SetQRCodeArray] = useState([]);
  const [EnableAllPdf, SetEnableAllPdf] = useState(false);
  const [AdjustedQty, setAdjustedQty] = useState([]);
  const [MoldMaster, setMoldMaster] = useState([]);


  const [Type, setType] = useState("");
  const [Quantity, setQuantity] = useState("");



  const [Remarks, setRemarks] = useState("");
  const [RawMaterialData, setRawMaterialData] = useState([]);
 const [CurrentPage, setCurrentPage] = useState(1);
    const [TotalPage, setTotalPage] = useState(0);
    const [PageSize, setPageSize] = useState(50);

  const [Date, setDate] = useState([]);
  const [spareList, setspareList] = useState([]);
  const { Panel } = Collapse;
  function callback(key) {
    console.log(key);
  }
  console.log(PdfData, "vhfvhdfvbhbvd");
  const handelOnPDfEnable = (e, input) => {
    let data = [...componentList];

    if (e.currentTarget.checked) {
      // Enable the PDF and add it to the list if not already present
      const exists = data.some((item) => item._id === input._id);

      if (!exists) {
        const updatedInput = { ...input, Enable: true }; // Avoid mutating input
        data.push(updatedInput);
      } else {
        data = data.map((item) =>
          item._id === input._id ? { ...item, Enable: true } : item
        );
      }

      SetEnableAllPdf(true); // Set "EnableAllPdf" to true
    }
    if (!e.currentTarget.checked) {
      data = data.map((item) => {
        console.log("jhveffj", item._id === input._id, item, input);
        return item._id === input._id ? { ...item, Enable: false } : item;
      });
    }
    setcomponentList(data);
    console.log(e.currentTarget.checked, "sdhbsdfusd", data);
    setPdfData(data);
  };
  const handleDownloadExcel = (e) => {
    generateExcelFile(e);
  };

  const columns = [
   
   
      {
          path: "DateTime",
          label: "Creation Date / Time ",
          content: (obj) => (
            <label>{moment(obj.DateTime).format("DD-MM-YY / hh:mm a")}</label>
          ),
        },
        {
          path: "ValidTill",
          label: "Valid Till Date / Time ",
          content: (obj) => (
            <label>{moment(obj.ValidTill).format("DD-MM-YY / hh:mm a")}</label>
          ),
        },
      {
      key: "update",
      content: (user) => (
        <button
          // disabled={
          //   !getRightsForAccess("StaticDataRights", RightName, "update")
          // }
          onClick={() => {
            // setInputData(user)
            console.log(user, "dshvgvbskbvksjb");
            setUpdate(user);
            setopStatus("view");
          }}
          className="btn btn-sm btn-primary"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
    },
    // { key: 'view', content: user => <button onClick={() => onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
    // { key: 'delete', content: user => <button disabled={!getRightsForAccess('StaticDataRights', RightName, "update")} onClick={() => onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }
  ];

  useEffect(() => {
    if (opStatus == "view") {
      setRows(Update.checkpoints);
      setQRCodeVisible(true);
      setInputData(Update);
      setmodelState(true);
    } else {
      setRows([]);
    }
  }, [opStatus]);

  console.log(Update, "wkhfwehkf");
  useEffect(() => {
    //     axios
    //       .get(api.api + "uploadImage")
    //       .then((result) => {
    //         console.log(result.data, "hvhfvdhfs");
    //         setImageList(result.data);
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    //  axios
    //       .get(api.api + "uploadImage")
    //       .then((result) => {
    //         console.log(result.data, "hvhfvdhfs");
    //         setImageList(result.data);
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });

    Heading("Oil Checkpoints Logs");

  
  }, []);

   useEffect(() => {
      RawMatreialMaster()
      }, [CurrentPage, PageSize]);
  
  const RawMatreialMaster = () => {
    // axios
    //   .get(api.api + "oilCheckpoints")
    //   .then((result) => {
    //     setRawMaterialData(result.data);
    //     // setRawMaterialData([ {
    //     //   DateTime:'04-04-2025',
    //     //   Oilbatches:[{RM_ID:'234', Vendor:'234', InvoiceDate:'234', InvoiceNo:'234'}],
    //     // },
    //     // {
    //     //   DateTime:'04-04-2025',
    //     //   Oilbatches:[{RM_ID:'234', Vendor:'234', InvoiceDate:'234', InvoiceNo:'234'}],
    //     // },
    //     // {
    //     //   DateTime:'04-04-2025',
    //     //   Oilbatches:[{RM_ID:'234', Vendor:'234', InvoiceDate:'234', InvoiceNo:'234'}],
    //     // },
    //     // ]);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    setLoader(true)
      axios.put(api.api + 'oilCheckpoints', { query: '', PageSize: PageSize, Page: CurrentPage })
          .then((result) => {
              setLoader(false)
              console.log(result.data.result,"jjkfhshf")
              setRawMaterialData(result.data.data);
              setTotalPage(result.data.totalDocuments
              );
              console.log(result.data, "-----------------");
          })
          
          .catch((err) => {
              setLoader(false)
              console.log(err);
          })
  };
  

  const downloadPDF = async (qrCodeGroups, Inputdata) => {
    console.log(qrCodeGroups, Inputdata, "currect dowload function dta");
    const pdf = new jsPDF("p", "mm", "b5");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName("a4-page")[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save(
      `${Inputdata.RM_Type ?? "pdf"}_${Inputdata.InvoiceNo ?? "data"}_${
        Inputdata.TestReportNo ?? "one"
      }.pdf`
    );

    if (opStatus !== "view") {
      handleCloseModel();
    }
  };

  const A4Sheet = (QRCodeVisible, Inputdata) => {
    // Split the QR codes into groups of 4
    const qrCodeGroups = [];
    const stickersPerPage = 16; // 4x4 grid on each page
    if (QRCodeVisible) {
      const totalStickers = Number(Inputdata.NumOfStickers);
      // const stickersPerPage = 9; // 3x3 grid on each page
      for (let i = 0; i < totalStickers; i += stickersPerPage) {
        qrCodeGroups.push(
          [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
            (_, j) => i + j
          )
        );
      }
    }

    // Prepare the QR Code value to display in each QRCodeSVG
    const QrCode = `CC : ${Inputdata.RM_Type};BN : ${
      Inputdata.InvoiceNo
    };TC : ${Inputdata.TestReportNo};MD : ${moment(
      Inputdata.InvoiceDate
    ).format("DD-MM-YY")};ED : ${moment(Inputdata.ExpiryDate).format(
      "DD-MM-YY"
    )};QT : ${Inputdata.Qty}`;

    return (
      <div>
        {opStatus === "view" && (
          <Button
            type="primary"
            onClick={() => downloadPDF(qrCodeGroups, Inputdata)}
            style={{ marginBottom: "16px" }}
          >
            Download as PDF
          </Button>
        )}

        <div className="a4-sheet-scrollable">
          {qrCodeGroups.map((group, pageIndex) => (
            <div
              className="a4-page"
              key={pageIndex}
              style={{ pageBreakAfter: "always" }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: `repeat(${Math.sqrt(
                    stickersPerPage
                  )}, 1fr)`, // 3 columns in each row
                  gridTemplateRows: `repeat(${Math.sqrt(
                    stickersPerPage
                  )}, auto)`, // 3 rows per page (auto height)
                  gap: "35px", // Optional: Adjust the gap between items as needed
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                {group.map((index) => (
                  <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    key={index}
                    style={{ textAlign: "center" }}
                  >
                    <QRCodeSVG value={QrCode} level="M" size={90} />{" "}
                    {/* Adjust the size of the QR code */}
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.RM_Type}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.InvoiceNo}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >{`${index + 1} / ${Inputdata.NumOfStickers}`}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleSort = (sortColumn) => {
    if (componentList.length > 0) {
      const sorted = _.orderBy(
        componentList,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);

      setcomponentList(sorted);
    }
  };
  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleCloseModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const handleHideModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const schema = {
    InvoiceNo: joi.string().required(),
    RM_Type: joi.string().required(),
    TestReportNo: joi.string().required(),
    InvoiceDate: joi.string().required(),
    ExpiryDate: joi.string().required(),
    Qty: joi.number().required(),
    NumOfStickers: joi.number().required(),
    _id: joi.string(),
  };

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;

    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(
      (column) => column.DbFieldName
    );
    headers.unshift("StandardType");
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns];
    return columns.filter((x) => !x.DataType.startsWith("UserInput"));
  };

 


  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${
              dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handelSaveData = (data) => {
    console.log(data, "cvosjnvjnv");
    const checksheet = { ...data };
    // delete checksheet.__v
    // delete checksheet.createdAt
    // delete checksheet.updatedAt
    const errors = validation.validate(checksheet, schema);
    if (errors) {
      seterrors(errors);
      return;
    }
    setLoader(true);
    if (opStatus == "update") {
      axios
        .patch(api.api + "compoundCode/" + Update._id, checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          setQRCodeVisible(true);

          // handleCloseModel()
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "compoundCode", checksheet)
        .then((result) => {
          console.log(result, "cdisivbi");
          swal("Data Saved Successfully");
          // Split the QR codes into groups of 4
          setQRCodeVisible(true);
          const qrCodeGroups = [];
          const stickersPerPage = 16; // 4x4 grid on each page
          // if (QRCodeVisible) {
          const totalStickers = Number(Inputdata.NumOfStickers);
          // const stickersPerPage = 9; // 3x3 grid on each page
          for (let i = 0; i < totalStickers; i += stickersPerPage) {
            qrCodeGroups.push(
              [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
                (_, j) => i + j
              )
            );
          }
          // }
          if (qrCodeGroups.length > 0) {
            downloadPDF(qrCodeGroups, Inputdata);
          }
          // if(Result){
          //   handleCloseModel()
          // }

          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  const downloadPDFforAll = (data) => {
    const pdf = [];

    data.map(
      (one) =>
        one.Enable &&
        [...Array(Math.min(one.NumOfStickers))].forEach((_, j) => {
          pdf.push({
            QrCode: `CC : ${one.CompoundCode};BN : ${one.InvoiceNo};TC : ${
              one.TestReportNo
            };MD : ${moment(one.InvoiceDate).format("DD-MM-YY")};ED : ${moment(
              one.ExpiryDate
            ).format("DD-MM-YY")};QT : ${one.Qty}`,
            index: j,
            InvoiceNo: one.InvoiceNo,
            CompoundCode: one.CompoundCode,
            TestReportNo: one.TestReportNo,

            NumOfStickers: one.NumOfStickers,
          });
        })
    );
    const qrCodeGroups = [];
    const stickersPerPage = 20; // 4x4 grid on each page
    // if (QRCodeVisible) {
    const totalStickers = Number(pdf.length);
    // const stickersPerPage = 9; // 3x3 grid on each page
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    // }
    console.log("downloadPDF", data, pdf, qrCodeGroups);
    setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  };

  const handelONaddSpare = (Date, Type, Quantity, Remarks) => {
    if(Date && Type && Quantity ){
      setAdjustedQty((prev) => [
        ...prev,
        { Date: Date, Type: Type, Quantity: Quantity,Remarks :Remarks},
      ]);
    }else{
      swal('Please Fill Required Fields')
    }
    setDate("");
    setQuantity("");
  
    setType("");
    setRemarks("");
  };
  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState}
        onHide={handleHideModel}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Oil Checkpoints</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}
          <Row>
         <Col sm={12}>
                       <div className="form-group mt-2 w-100 d-flex">
                         <div className="w-25"  htmlFor="operationRejectionCost"> Date</div >
                         <div className="w-75">
                         <input
                           required
                           onChange={handleOnChange}
                          disabled={true}
                           placeholder=" Date"
                           className="form-control form-control-sm"
                           type="text"
                           name="Date"
                           value={(Inputdata.DateTime &&
                                                moment(Inputdata.DateTime).format('DD-MM-YYYY') ) ||
                                               ""
                           }
                         />
                         </div>
                       
                         {errors.DateTime && (
                           <div className="alert small alert-danger">
                             {errors["DateTime"]}
                           </div>
                         )}
                       </div>
                     </Col>{" "}
                     <Col sm={12}>
                       <div className="form-group mt-2 ">
                          <div className="">
                          {Inputdata.OilBatches && Inputdata.OilBatches.length > 0 ?  <div className="col-sm-2 text-nowrap">
            <button   onClick={() => handleDownloadExcel("OilCheckpointReport")}className="btn-sm btn-primary ">Download  Report</button>
        </div>:''}
                         <div  htmlFor="operationRejectionCost"> Oil Batches :</div >
         
                                             <table id="OilCheckpointReport" className="table table-striped small table-bordered table-sm table-hover common my-1">
                                               <thead className="small">
                                                 <tr className="table-primary text-center common-anchor">
                                                   <td>Date</td>
                                                   <td>RM ID</td>
                                                   <td>Vendor</td>
                                                   <td>Invoice Date</td>
                                                   <td>Invoice No</td>
                         
                                                 </tr>
                                               </thead>
                                               <tbody>
                                               
                                               {Inputdata.OilBatches && Inputdata.OilBatches.length > 0 &&
                                                   Inputdata.OilBatches.map((item) => (
                                                     <tr  className="text-center">
                                                     <td >{moment(item.Date).format('DD-MM-YYYY')}</td>
                                                     <td >{item?.RM_ID?.RM_ID}</td>
                                                     <td >{item?.RM_ID?.Vendor}</td>
                                                    <td >{item.RM_ID && item.RM_ID.InvoiceDate && moment(item.RM_ID.InvoiceDate).format('DD-MM-YYYY')}</td>

                                                     <td >{item?.RM_ID?.InvoiceNo}</td>
                                                   </tr>
                                                   
                                                   ))}
                         
                                               </tbody>
                                             </table>
                                           </div>
                          
                         {errors.InvoiceNo && (
                           <div className="alert small alert-danger">
                             {errors["InvoiceNo"]}
                           </div>
                         )}
                       </div>
                     </Col>
                    
          </Row>
       
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()}>
            Close
          </Button>
          {opStatus === "view" ? (
            ""
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                const error = validateCheckCheckPoints(rows);
                if (error.IsError) {
                  swal("ERROR", error.message.join(", "), { dangerMode: true });
                } else {
                  handelSaveData(Inputdata);
                }
              }}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState1}
        onHide={handleHideModel1}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Inventory Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

          {console.log(Inputdata.NumOfStickers, "snsdonsdn")}
          <div className="a4-sheet">
            {
              QRCodeArray && QRCodeArray.length > 0 && (
                <div>
                  <Button
                    type="primary"
                    onClick={() => downloadPDF(QRCodeArray, Inputdata)}
                    style={{ marginBottom: "16px" }}
                  >
                    Download as PDF
                  </Button>

                  {QRCodeArray.map((group, index) => (
                    <div className="a4-sheet-scrollable">
                      <div
                        className="a4-page"
                        // key={pageIndex}
                        style={{ pageBreakAfter: "always" }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: `repeat(${Math.sqrt(
                              16
                            )}, 1fr)`, // 3 columns in each row
                            gridTemplateRows: `repeat(${Math.sqrt(16)}, auto)`, // 3 rows per page (auto height)
                            gap: "35px", // Optional: Adjust the gap between items as needed
                            justifyItems: "center",
                            alignItems: "center",
                          }}
                        >
                          {group.map((one, index) => (
                            <div
                              className="d-flex flex-column justify-content-center align-items-center"
                              key={index}
                              style={{ textAlign: "center" }}
                            >
                              <QRCodeSVG value={one.QrCode} level="M"  size={105}
                                    style={{ marginBottom: "3px" }} />{" "}
                              {/* Adjust the size of the QR code */}
                              <p
                                style={{
                                  fontSize: "9px",
                                  color: "black",
                                  letterSpacing: "0.5px",
                                  lineHeight: "1.2",
                                }}
                                className="bolder p-0 m-0"
                              >
                                {one.RM_Type}
                                <br />
                                {one.InvoiceNo}
                                <br />

                                {`${1 + one.index} / ${one.NumOfStickers}`}

                              </p>
                            
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )
              // [...Array(Number(Inputdata.NumOfStickers))].map((_, index) => (
              //   <Space className="qr-space" key={index} direction="vertical" align="center">
              //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
              //     <p>{index + 1 + ' / ' + Inputdata.NumOfStickers}</p>
              //   </Space>
              // ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel1()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {
        <button
          disabled={!getRightsForAccess("StaticDataRights", RightName, "write")}
          className="btn-sm btn-primary float-right"
          onClick={() => {
            setQRCodeVisible(false);
            setmodelState(true);
            setInputData({});
            setUpdate({});
            setSelectedTemplate({});
          }}
        >
          Create Refill
        </button>
      } */}
      {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    // onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Import Excel</button> */}
      {/* {getRightsForAccess('StaticDataRights', RightName, "write") && <Excelimport />} */}
      {PdfData && PdfData.length > 0 && EnableAllPdf && (
        <button
          type="button"
          className="btn-sm btn-primary"
          onClick={() => downloadPDFforAll(PdfData)}
        >
          Download PDFs
        </button>
      )}
      {RawMaterialData && RawMaterialData.length > 0 ?  <div className="col-sm-2 text-nowrap">
            <button   onClick={() => handleDownloadExcel("OilCheckpointReport")}className="btn-sm btn-primary ">Download  Report</button>
        </div>:''}
      {RawMaterialData.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
        id="OilCheckpointReport"
          columns={columns}
          onSort={handleSort}
          sortColumn={sortColumn}
          data={RawMaterialData}
        />
      )}
       {RawMaterialData.length > 0 && <div className="float-end m-3">
                <PaginationComponent  defaultCurrent={CurrentPage} total={TotalPage} CurrentPageNumber={(currentpage, pagesize) => { setCurrentPage(currentpage); setPageSize(pagesize) }} />
            </div>}
    </>
  );
};

export default OilCheckpoints ;
